import type { EventSourceMessage } from '@microsoft/fetch-event-source';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { objectToFormData } from '../utils/util';
import { getCommonParams } from '../api/common-params';

interface ISSEOptions {
  url: string;
  params?: Record<string, any>;
  onopen?: (response: Response) => any;
  onmessage?: (ev: EventSourceMessage) => void;
  onclose?: () => void;
  onerror?: (err: any) => number | null | undefined | void;
}

export default class SSEManager {
  private options: ISSEOptions;

  constructor(options: ISSEOptions) {
    this.options = options;
    this.connect();
  }

  private ctrl = new AbortController();
  public connect() {
    const { url, params = {}, onopen, onmessage, onerror } = this.options;
    const requestParams = {
      ...params,
      ...getCommonParams(),
    };
    fetchEventSource(url, {
      signal: this.ctrl.signal,
      method: 'post',
      body: objectToFormData(requestParams),
      openWhenHidden: true,
      onopen,
      onmessage: e => {
        console.log('接收到sse消息 123', e);
        onmessage && onmessage(e);
      },
      onerror,
    });
  }

  public close() {
    if (this.ctrl) {
      this.ctrl.abort();
    }
  }
}
